import React, { Component, useEffect, useRef, useState } from "react";

// @ mui icons
import FilterListIcon from "@mui/icons-material/FilterList";
import ImportExportIcon from "@mui/icons-material/ImportExport";

// common components
import Header from "../components/common/MagicPageHeader";
import TableHeader from "../components/common/MagicTableHeader";
import MagicDrawer from "../components/common/MagicDrawer_new";
import Table from "../components/common/MagicTable";
import Stack from "../components/mui/Stack";
import Tabs from "../components/targetAchivment/Tabs";
import TargetAchivmentfilterForm from "../components/targetAchivment/TargetAchivmentfilterForm";
import ApproveDataFilter from "../components/targetAchivment/ApproveDataFilter";
import Button from "../components/mui/Button";
import { useLocation } from "react-router-dom";
import {
  useCenterListQuery,
  useFetchedFunderQuery,
  useUserListQuery,
} from "../store/apis/centerApis";
import { City, State } from "country-state-city";
import {
  useDeleteDataInputMutation,
  useGetTargetAchievementQuery,
  useLazyGetTargetAchievementQuery,
  useLazyTableHeaderDataByIdQuery,
} from "../store/apis/targetApis";
import ImageComponent from "../components/mui/Image";
import Dialog from "../components/common/Dialog";
import ImportCenterContent from "../components/centres/ImportCenterContent";
import ImportTargetContainer from "../components/targetAchivment/ImportTragetContainer";
import { useAppSelector } from "../hooks/reduxHooks";
import { RootState } from "../store";
import DownloadToXlsxFile from "../helper/DownloadToXlsxFile";
import usePermission from "../helper/usePermission";
import { acl } from "../helper/userAccessConstant";
import { useFetchManageAwardQuery } from "../store/apis/reportsApis";

// import Text from "../components/mui/Text";
import Text from "../components/mui/Text";
import Box from "../components/mui/Box";
import Modal from "../components/common/Modal";
import { showToast } from "../helper/toaster";
// import { isDisabled } from "@testing-library/user-event/dist/utils";

interface TabCategory {
  id: number;
  name: string;
  targetCount: number;
}

interface IndianCity {
  label: string;
  id: string;
}

type Cities = IndianCity[];

const DataInput: React.FC = () => {
  const location = useLocation();
  const programs = useAppSelector((state: RootState) => state.user.filter);

  const moduleData =
    Array.isArray(location?.state?.data?.tabDetails) &&
    location.state.data.tabDetails.length > 0
      ? location.state.data.tabDetails
      : {};

  const { permissions } = usePermission();

  const [userModuleAccess, setUserModuleAccess] = useState<any>({
    canRead: false,
    canWrite: false,
    canUpdate: false,
    canDelete: false,
  });

  const masterData = permissions[acl.data_input.module];

  const { canRead, canWrite, canUpdate, canDelete } =
    permissions[acl.data_input.module]?.data_input;

  const handleUserData = (permissionData: any, data: string) => {
    const permission = permissionData[data];

    if (permission?.canRead) {
      setUserModuleAccess({
        canRead: permission.canRead || false,
        canWrite: permission.canWrite || false,
        canUpdate: permission.canUpdate || false,
        canDelete: permission.canDelete || false,
      });
    } else {
      console.log(`No read access for ${data}`);
    }
  };

  const [finalData, setFinalData] = useState<any>({});
  const [isOpenApproveData, setIsOpenApproveData] = useState<boolean>(false);
  const [isOpenFilterForm, setIsOpenFilterForm] = useState<boolean>(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [isLessThen3Value, setIsLessThen3Value] = useState<boolean>(false);
  const [isImportDialog, setIsImportDialog] = useState<boolean>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<any>([]);
  const [isSixerClass, setisSixerClass] = useState<any>(false);

  const [importConfirmationModal, setImportConfirmationModal] =
    useState<boolean>(false);
  const [isDisabledImport, setIsDisabledImport] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState("");
  const [filter, setFilter] = useState<any>({
    centers: "",
    medals: "",
    state: "",
    city: "",
    regionalManager: "",
    cityManager: "",
    clusterManager: "",
    funder: "",
    region: "",
  });
  const [selectedTab, setSelectedTab] = useState<TabCategory | null>(null);
  const [currentPage, setCurrentPage] = useState<any>(1);
  const [params, setParams] = useState<any>({
    pageNo: "1",
    pageSize: "10",
    targetAchievementTabId: finalData?.tabId || null,
    programMasterId: programs?.selectedProgram?.value || undefined,
    programYearId: programs?.selectedYear?.value || undefined,
    quarterMasterId: programs?.selectedQuarter?.quarterMasterId || undefined,
  });

  const [cities, setCities] = useState<Cities>([]);

  const indianStates: { label: string; id: string }[] =
    State.getStatesOfCountry("IN")?.map((state: any) => ({
      label: state.name,
      id: state.isoCode,
    })) || [];

  useEffect(() => {
    setParams({
      pageNo: "1",
      pageSize: "10",
      targetAchievementTabId: finalData?.tabId || null,
      programMasterId: programs?.selectedProgram?.value || undefined,
      programYearId: programs?.selectedYear?.value || undefined,
      quarterMasterId: programs?.selectedQuarter?.quarterMasterId || undefined,
    });

    handleUserData(masterData, finalData?.tabId);
  }, [location, programs, finalData?.tabId]);

  useEffect(() => {
    if (Array.isArray(moduleData) && moduleData?.length > 1) {
      handleSubTabsChange(1);
      setFinalData(moduleData[0]); // Always setting index 0 when location updates
      setisSixerClass(moduleData[0]?.tabId === "sixer_class_data");
    } else {
      setFinalData(moduleData[0]); // Ensuring only one object is set
      setisSixerClass(moduleData[0]?.tabId === "sixer_class_data");
    }
  }, [location]);

  useEffect(() => {
    setParams({
      pageNo: "1",
      pageSize: "10",
      targetAchievementTabId: finalData?.tabId || null,
      programMasterId: programs?.selectedProgram?.value || undefined,
      programYearId: programs?.selectedYear?.value || undefined,
      quarterMasterId: programs?.selectedQuarter?.quarterMasterId || undefined,
    });
  }, [programs]);

  //Api calls

  const { data: regionalDirector = [], isLoading: isLoadingRegionalDirector } =
    useUserListQuery({ roleId: "3" });

  const { data: cityManager = [], isLoading: isLoadingCityManger } =
    useUserListQuery({ roleId: "4" });
  const { data: clusterManager = [], isLoading: isLoadingClusterManager } =
    useUserListQuery({ roleId: "5" });
  const { data: fetchedFunder = [] } = useFetchedFunderQuery();
  const { data: centerListOptions = {}, refetch: centerListRefetch } =
    useCenterListQuery(
      {
        state: filter.state ? filter?.state?.label : undefined,
        district: filter.city ? filter?.city?.label : undefined,
        region: filter.region ? filter?.region : undefined,
        pageNo: "1",
        pageSize: "10000",
      },
      { refetchOnMountOrArgChange: true }
    );
  const { data: medals } = useFetchManageAwardQuery();
  // const cities = Array.from(new Set(centerListOptions?.citySelect || []))?.map(
  //   (c) => ({ label: c, id: c })
  // );

  const {
    data: targetTableData,
    isLoading: isLoadingTargetTableData,
    isFetching: isFetchingTargetTableData,
  } = useGetTargetAchievementQuery(params);

  const [trigger, { data, error, isLoading }] =
    useLazyGetTargetAchievementQuery({});

  const [deleteDataInput, { isLoading: dataInputDeleting }] =
    useDeleteDataInputMutation();

  // const indianStates: { label: string; id: string }[] =
  //   State.getStatesOfCountry("IN")?.map((state: any) => ({
  //     label: state.name,
  //     id: state.isoCode,
  //   })) || [];

  const toggleFilerFormDrawer = () => {
    setIsOpenFilterForm((preState) => !preState);
  };

  const handleApproveDataBtnClick = () => {
    setIsOpenApproveData((preState) => !preState);
  };

  const toggleImport = () => {
    setIsImportDialog(!isImportDialog);
  };

  const handleImport = async () => {
    setImportConfirmationModal(true);
    handleApproveDataBtnClick();
    setTimeout(() => {
      setImportConfirmationModal(false); // Automatically close it after 5 seconds
    }, 5000);
  };

  const handleDialogClose = (
    event: {},
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    setImportConfirmationModal(false);
  };

  const handleApplyFilterBtn = (): void => {
    const payload = {
      pageNo: "1",
      pageSize: "10",
      centerId: filter?.centers?.id,
      cityManagerUserId: filter?.cityManager?.id,
      medals: filter?.medals?.id,
      state: filter?.state?.label,
      district: filter?.city?.label,
      regionalManager: filter?.regionalManager?.id,
      clusterManager: filter?.clusterManager?.id,
      funder: filter?.funder?.id,
      region: filter?.region,
      programMasterId: programs?.selectedProgram?.value || undefined,
      programYearId: programs?.selectedYear?.value || undefined,
      quarterMasterId: programs?.selectedQuarter?.quarterMasterId || undefined,
    };
    setParams((pre: any) => ({ ...pre, ...payload }));
    // toggleFilerFormDrawer();
  };

  const handleClearAllFilterBtn = (): void => {
    setFilter({
      centers: "",
      medals: "",
      state: "",
      city: "",
      regionalManager: "",
      cityManager: "",
      clusterManager: "",
      funder: "",
      region: "",
    });
    setParams({
      ...(searchValue && { search: searchValue }),
      pageNo: "1",
      pageSize: "10",
      targetAchievementTabId: finalData?.tabId || null,
      programMasterId: programs?.selectedProgram?.value || undefined,
      programYearId: programs?.selectedYear?.value || undefined,
      quarterMasterId: programs?.selectedQuarter?.quarterMasterId || undefined,
    });
    // toggleFilerFormDrawer();
  };
  const handleReportSearch = (value: string | number) => {
    const searchValue = value.toString();
    const isLessThan3 = searchValue.length > 0 && searchValue.length < 3;
    setIsLessThen3Value(isLessThan3);
    setSearchValue(searchValue);

    // Clear the previous timeout to reset the timer if the user is typing quickly
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Only set params after 1.5 seconds of no new typing
    timeoutRef.current = setTimeout(() => {
      setParams((prevParams: any) => {
        if (searchValue.length >= 3) {
          return {
            ...prevParams,
            search: searchValue,
            pageNo: "1",
            pageSize: "10",
            targetAchievementTabId: finalData?.tabId || null,
          };
        } else if (searchValue.length === 0 && prevParams.search) {
          return {
            ...prevParams,
            search: undefined,
            pageNo: "1",
            pageSize: "10",
            targetAchievementTabId: finalData?.tabId || null,
          };
        }
        return prevParams; // Return unchanged state if conditions are not met
      });
    }, 1500);
  };

  // Pagination Function
  const handlePagination = (event: any, pageNo: number) => {
    setParams((prevParams: any) => ({
      ...prevParams,
      pageNo: pageNo.toString(),
      pageSize: "10",
      targetAchievementTabId: finalData?.tabId || null,
      ...(searchValue && { search: searchValue }),
    }));
    setCurrentPage(pageNo);
  };

  const onDelete = async () => {
    try {
      const res = await deleteDataInput(selectedData?.targetParameterID);
      toggleDeleteModal();
      if (res.data?.success) {
        if (targetTableData?.tableData?.length === 1) {
          setParams((prevParams: any) => ({
            ...prevParams,
            pageSize: "10",
            pageNo: Math.max(prevParams.pageNo - 1, 1),
          }));
        }
        showToast(
          res?.data?.message || "Manage award delete successfully",
          "success"
        );
      }
    } catch (error) {
      console.error("Error deleting award:", error);
    }
  };

  const toggleDeleteModal = () =>
    setIsDeleteModalOpen((prevState) => !prevState);

  const handleDeleteModal = (data: any) => {
    setSelectedData(data);
    toggleDeleteModal();
  };

  // Buttons
  const magicPageHeaderBtn = [
    {
      text: "Import",
      variant: "outlined",
      startIcon: (
        <ImageComponent
          src="/assets/images/icon/download.svg"
          alt="download"
          imgStyle={{
            opacity:
              targetTableData?.isApproved || !userModuleAccess.canWrite
                ? "0.3"
                : "1",
          }}
        />
      ),
      disabled: targetTableData?.isApproved || !userModuleAccess.canWrite,
      onClick: toggleImport,
      loading: isLoading,
      sx: {
        color: "black",
        textTransform: "capitalize",
        border: "1px solid #8D8D8D",
        backgroundColor: "#fff",
        "&:hover": {
          backgroundColor: "#ededed",
        },
        borderRadius: "8px",
      },
    },
  ];
  // Header Buttons
  const magicTableHeaderBtn = [
    {
      text: "Add Filters",
      variant: "outlined",
      startIcon: <FilterListIcon />,
      onClick: toggleFilerFormDrawer,
      sx: {
        color: "black",
        textTransform: "capitalize",
        border: "1px solid #a18218",
        backgroundColor: "#fff1b7",
        "&:hover": {
          backgroundColor: "#e8d78e",
        },
        borderRadius: "8px",
      },
    },
  ];

  const coloumGenerator = (data: any) => {
    if (!Array.isArray(data)) {
      console.error("Invalid data provided: Must be an array");
      return [];
    }

    return [
      {
        field: "region",
        headerName: "Region",
        minWidth: 125,
      },
      {
        field: "funderName",
        headerName: "Funder Name",
        minWidth: 125,
      },
      {
        field: "centerName",
        headerName: "Center Name",
        minWidth: 300,
      },
      {
        field: "projectCode",
        headerName: "Project Code",
        minWidth: 125,
      },
      {
        field: "state",
        headerName: "State",
        minWidth: 125,
      },
      {
        field: "district",
        headerName: "City",
        minWidth: 125,
      },
      {
        field: "cityManager",
        headerName: "City Manager",
        minWidth: 125,
      },
      {
        field: "centerStatus",
        headerName: "Center Status",
        minWidth: 125,
      },

      ...data.map((item, index) => ({
        field: item?.id || item?.name || `field${index}`, // Fallback in case item.id is undefined
        headerName: item?.name || `Column ${index + 1}`,
        ...(data.length > 1 ? { minWidth: 200 } : { flex: 1 }),
        renderCell: (params: any) => {
          const value = params.value;
          console.log(params?.field);
          const handleValue = () => {
            if (params?.field.match("Date")) {
              return new Date(value).toLocaleDateString() || "0";
            } else if (params?.field == "attendancePercentage") {
              return value ? value?.result || value?.toString() : "0";
            } else {
              return value ? value.toString() : "0";
            }
          };
          return handleValue();
        },
      })),
      {
        field: "action",
        headerName: "action",
        minWidth: 125,
        renderCell: (props: { row: any }) => {
          return (
            <Button
              variant="outlined"
              sx={{
                border: "1px solid #EAECF0",
                padding: "9px 0px !important",
                borderRadius: "12px",
                minWidth: "45px",
              }}
              disabled={!canDelete}
              onClick={() => handleDeleteModal(props.row)}
            >
              <ImageComponent
                src="/assets/images/icon/delete.svg"
                alt="editPen"
              />
            </Button>
          );
        },
      },
    ];
  };

  const ratiobtn = [
    { label: "East", value: "East" },
    { label: "West", value: "West" },
    { label: "North", value: "North" },
    { label: "South", value: "South" },
  ];

  const centerList = {
    centerSelect: centerListOptions?.centerSelect,
    regionalDirectorOptions: regionalDirector,
    cityManagerOptions: cityManager,
    stateOptions: indianStates,
    clusterManagerOptions: clusterManager,
    funderOptions: fetchedFunder,
    medals: medals,
    city: cities,
  };

  const handleFilterFormChange = (field: string, value: any) => {
    if (field == "region") {
      setFilter((prevFilter: any) => {
        return { region: prevFilter.region == value ? "" : value }; // Ensure you return the updated state
      });
      return;
    }
    if (field === "state") {
      const indianCities: IndianCity[] = value?.id
        ? City.getCitiesOfState("IN", value?.id).map((city: any) => ({
            label: city.name,
            id: city.name,
          }))
        : [];
      setCities(indianCities);
    }
    setFilter((prevFilter: any) => ({
      ...prevFilter,
      [field]: value,
    }));
  };

  const formattedData =
    targetTableData?.tableData?.map((item: any, tableIndex: number) => {
      // Extract and transform parameters into the desired format
      const parametersData = Object.entries(item.parameters || {}).reduce(
        (acc: any, [key, value]: [string, any]) => {
          acc[key] = value === null ? "-" : value; // Map each key-value pair, defaulting to null for missing values
          return acc;
        },
        { id: tableIndex + 1, targetParameterID: item.targetAchievementId } // Start with an object containing the id
      );
      return parametersData;
    }) || [];

  const totalPages = Math.ceil(targetTableData?.tableDataRowCount / 10);

  const tableData = Array.isArray(moduleData)
    ? moduleData?.map((item: any, tableIndex: number) => ({
        ...item,
        id: tableIndex + 1,
        name: item?.tabName || "-",
      }))
    : [];

  const handleSubTabsChange = (id: number) => {
    const selectedCategory = tableData?.find((category) => category?.id === id);

    if (selectedCategory) {
      setFinalData(selectedCategory);
    } else {
      console.log("Category not found for ID:", id);
    }
  };

  console.log({ formattedData }, coloumGenerator(finalData?.parameterFields));

  return (
    <>
      <Modal open={isDeleteModalOpen} disableClose={true}>
        <>
          <Box
            padding={1}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "12px",
              flexDirection: "column",
            }}
          >
            <Box height={"50px"}>
              <ImageComponent src="/assets/images/icon/warning.svg" />
            </Box>
            <Text
              sx={{ color: "#101828", fontWeight: "600", fontSize: "18px" }}
            >
              Are you sure you want to delete this?
            </Text>
            <Text
              sx={{
                color: "#667085",
                fontSize: "14px",
                fontWeight: "400",
                textAlign: "center",
              }}
            >
              By clicking on the Delete button you are making sure that you want
              to delete this permanently.
            </Text>

            <Stack flexDirection={"row"} width={"100%"} gap="15px">
              <Button
                variant="contained"
                sx={{
                  flex: 1,
                  borderRadius: "8px",
                  border: "1px solid #8D8D8D",
                  backgroundColor: "#fff",
                  "&:hover": {
                    backgroundColor: "#ededed",
                  },
                }}
                onClick={toggleDeleteModal}
              >
                No
              </Button>
              <Button
                sx={{
                  flex: 1,
                  borderRadius: "8px",
                  border: "1px solid #a18218",
                  backgroundColor: "#fef7da",
                  "&:hover": {
                    backgroundColor: "#e8d78e",
                  },
                }}
                onClick={!dataInputDeleting ? onDelete : undefined}
              >
                {!dataInputDeleting ? "delete" : "Loading.."}
              </Button>
            </Stack>
          </Box>
        </>
      </Modal>

      <Stack>
        {moduleData?.length > 1 && (
          <Tabs tabs={tableData} handleTabChange={handleSubTabsChange} />
        )}

        <Header
          title={finalData?.tabName || "Operations HR data"}
          subTitle="Here you can view the targets given to the employees."
          buttons={userModuleAccess.canWrite ? magicPageHeaderBtn : []}
          chipLabel={`${
            isFetchingTargetTableData
              ? "0"
              : targetTableData?.tableDataRowCount || "0"
          } Target`}
        />

        <TableHeader
          buttons={magicTableHeaderBtn}
          searchTitle="Search by centre name"
          onSearchfieldChange={handleReportSearch}
        />

        <Table
          columns={coloumGenerator(finalData?.parameterFields)}
          rows={isFetchingTargetTableData ? [] : formattedData}
          loading={isFetchingTargetTableData}
          handlePageChange={handlePagination}
          count={isFetchingTargetTableData ? 1 : totalPages}
          rowCellsSx={{ paddingLeft: "16px", textAlign: "start" }}
          headerSx={{
            paddingLeft: "16px",
            textAlign: "start",
            fontWeight: 600,
            color: "#242424",
            padding: "13px 16px",
          }}
          sx={{
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#DADADA",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: 550,
              fontSize: "14px",
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "#FFFFFF",
            },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "#FFFFFF",
            },
            "& .MuiDataGrid-cell": {
              display: "flex",
              alignItems: "center",
            },
          }}
          tableSx={{ minHeight: "350px", width: "100%" }}
          getRowId={(row: any) => row?.id}
          currentPage={parseInt(params.pageNo) || parseInt(currentPage) || 1}
        />

        {/* <MagicDrawer
          title="Approve data"
          subtitle="Here you can approve the data by adding remark."
          drawerOpen={isOpenApproveData}
          onDrawerToggle={handleApproveDataBtnClick}
          actionComponent={() => (
            <>
              <Button
                className="bun-outline"
                onClick={handleClearAllFilterBtn}
                // disabled={isCreatingUser}
              >
                Cancel
              </Button>
              <Button
                className="bun-filled"
                onClick={handleApplyFilterBtn}
                // loading={isCreatingUser}
              >
                Approve
              </Button>
            </>
          )}
        >
          <ApproveDataFilter />
        </MagicDrawer> */}

        <MagicDrawer
          title="Add Filters"
          subtitle="See the data in an organized manner by applying filters"
          drawerOpen={isOpenFilterForm}
          onDrawerToggle={toggleFilerFormDrawer}
          actionComponent={() => (
            <>
              <Button
                className="bun-outline"
                onClick={handleClearAllFilterBtn}
                // disabled={isCreatingUser}
              >
                Clear All
              </Button>
              <Button
                className="bun-filled"
                onClick={handleApplyFilterBtn}
                // loading={isCreatingUser}
              >
                Apply
              </Button>
            </>
          )}
        >
          <TargetAchivmentfilterForm
            ratiobtn={ratiobtn}
            centerList={centerList}
            filter={filter}
            handleFilterFormChange={handleFilterFormChange}
          />
        </MagicDrawer>
      </Stack>

      <Dialog
        open={isImportDialog}
        onOpen={() => {}}
        onClose={toggleImport}
        maxWidth="sm"
        disabledBackdropClick={true}
      >
        <ImportTargetContainer
          onClose={toggleImport}
          toggleImport={toggleImport}
          onSuccess={handleImport}
          location={finalData}
          formatedData={formattedData}
          setIsDisabledImport={setIsDisabledImport}
          fileDownloadName={finalData?.tabName}
          isSixerClasTab={isSixerClass}
        />
      </Dialog>

      <Dialog
        open={importConfirmationModal}
        onOpen={() => {}}
        onClose={() => {
          setImportConfirmationModal(false);
          handleDialogClose("", "backdropClick");
        }}
        maxWidth="sm"
      >
        <div
          style={{
            padding: "40px 24px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {/* Icon Section */}
          <div style={{ marginBottom: "28px" }}>
            <ImageComponent
              sx={{ height: "34px", width: "34px" }}
              src="assets/images/login/SucessfullyImportIcon.svg"
              alt="Successfully Import Icon"
            />
          </div>

          {/* Title Text */}
          <div>
            <text
              style={{ color: "#101828", fontSize: "20px", fontWeight: "600" }}
            >
              The data input list has been successfully uploaded.
            </text>
          </div>

          {/* Description Text */}
          <div>
            <text
              style={{ color: "#667085", fontSize: "14px", fontWeight: "400" }}
            >
              The data input has been uploaded seamlessly, ensuring all data is
              now available for access and review.
            </text>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default DataInput;
